import Table from './Table'

export default Table



// WEBPACK FOOTER //
// ./src/legacy/containers/Tables/components/Table/index.js